export const multiLineGraphContainer = 'tid_multi-line-graph-container';
export const multiLineGraphLine = 'tid_multi-line-graph-line';
export const multiLineGraphBasePriceLine = 'tid_multi-line-graph-base-price-line';
export const multiLineGraphBatnaPriceLine = 'tid_multi-line-graph-batna-price-line';
export const multiLineGraphLabel = 'tid_multi-line-graph-label';
export const multiLineGraphContractStartLine = 'tid_multi-line-graph-contract-start-line';
export const multiLineGraphContractEndLine = 'tid_multi-line-graph-contract-end-line';
